import { useState } from "react";
import ButtonPanel, { ButtonDefinition, ButtonList } from "../buttonPanel";
import { MenuProps } from "./menuTypes";

const url_base = "http://localhost:8081";

const RemoteServerMenu = ({ model, setModel }: MenuProps) => {
  const [threadId, setThreadId] = useState<string>("");
  const aiChatCallback = async () => {
    const message = prompt("Chat message:");
    const response = await fetch(`${url_base}/msgassistant`, {
      method: "POST",
      mode: "cors",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: JSON.stringify(model),
        message,
        thread_id: threadId,
      }),
    });
    const jsonResponse = await response.json();
    if (jsonResponse.status == "success") {
      const newModel = jsonResponse.message;
      setModel(newModel);
    } else {
      alert(jsonResponse.message);
    }
  };
  const buttons: ButtonDefinition[] = [
    { label: "AI Chat", callback: aiChatCallback },
  ];
  return (
    <ButtonPanel
      title="RemoteServer"
      buttons={buttons}
      description="Utilize AI to build and update your knowledge graph"
    />
  );
};

export default RemoteServerMenu;
